import { h, render } from "preact";
import { useRef, useEffect } from "preact/hooks";
import RichText from "../helpers/richText";
import ModelRowContentVideo from "./modelRowContentVideo";

export default function ModelRowContentItem({ compareProduct }) {
  let media = compareProduct.product.featuredImage && (
    <img
      src={getSizedImageUrl(compareProduct.product.featuredImage.url, "x800")}
      alt={compareProduct.product.featuredImage.altText}
    />
  );

  if (compareProduct.customMedia) {
    if ("image" in compareProduct.customMedia) {
      media = (
        <img
          src={getSizedImageUrl(compareProduct.customMedia.image.url, "x800")}
          alt={compareProduct.customMedia.image.altText}
        />
      );
    }

    if ("sources" in compareProduct.customMedia) {
      media = <ModelRowContentVideo video={compareProduct.customMedia} />;
    }
  }

  return (
    <div className="compare-modal-v2__row-item">
      <div className="compare-modal-v2__model-media-wrapper">{media}</div>
      <h3 className="compare-modal-v2__model-title h4 strong">
        {compareProduct.product.title}
      </h3>
      <RichText
        className="compare-modal-v2__model-description"
        schema={compareProduct.description}
      />
    </div>
  );
}
